<td class="iss-cell" colspan="999">
  <div
    woNoData
    [height]="height"
    [title]="title?.template"
    [subtitle]="subtitle?.template"
  >
    <ng-content/>
  </div>
</td>
